enum Region {
    Turkey = 1,
    Egypt = 8,
    Russia = 9,
    Kazakhistan = 10,
    Georgia = 12,
    Iraq = 13,
    Morrocco = 17,
    Ukraine = 25,
    France = 28,
    Greece = 36,
    Italy = 39,
    Romania = 51,
    Bulgaria = 53,
    Serbia = 126,
    Germany = 26,
    Croatia = 59,
    Bosnia = 139,
    Albania = 144,
    Kosovo = 158,
    Macedonia = 115,
    Montenegro = 120,
}

export { Region };
